/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsGridSeller_item = {
    readonly serviceId: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsContainer_item">;
    readonly " $refType": "PdpRespSimilarItemsGridSeller_item";
};
export type PdpRespSimilarItemsGridSeller_item$data = PdpRespSimilarItemsGridSeller_item;
export type PdpRespSimilarItemsGridSeller_item$key = {
    readonly " $data"?: PdpRespSimilarItemsGridSeller_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGridSeller_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsGridSeller_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsContainer_item",
      "args": null
    }
  ]
};
})();
(node as any).hash = '7dcb959665aadd0b0f9cea8fa65662ee';
export default node;
